<div class="ppl-container-body">

  <!-- ── Header ──────────────────────────────────────────────────────────── -->
  <div class="ppl-container-head">
    <div class="details-header">
      <ppl-button label="Back" icon="fa fa-chevron-left" [customClass]="'ghost-button'" iconPosition="left"
        (click)="goBack()"></ppl-button>
      <h3 class="page-title-accessibility">Bulk Adjustment</h3>
    </div>
    <div class="action">
      <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'ghost-button'" [iconPosition]="'left'"
        [styleString]="'margin-right: 8px;'" (click)="onCancel()">
      </ppl-button>
      <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'primary-button'" [iconPosition]="'left'"
        [disabled]="isSaving || isUploadingFile" (click)="onSave()">
      </ppl-button>
    </div>
  </div>

  <!-- ── Body ────────────────────────────────────────────────────────────── -->
  <div class="ppl-container">
    <div class="ppl-content-container body-scroll">

      <ppl-accordion [title]="'Basic Information'" [isOpen]="true">
        <div class="wiz-body">
          <form nz-form nz-row [formGroup]="adjustmentForm" class="ppl-p0">

            <!-- Batch Source -->
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="batchProcessLkp" class="ppl-form-label">
                  Batch Source<span>*</span>
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                  <ppl-dropdown-select formControlName="batchProcessLkp" id="batchProcessLkp" class="ppl-select"
                    [options]="processType" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                    [placeholder]="'Select Batch For'" (selectionChange)="onBatchProcessChange($event)">
                  </ppl-dropdown-select>
                </nz-form-control>
              </nz-row>
            </nz-form-item>

            <!-- Batch Type -->
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="batchTypeLkp" class="ppl-form-label">
                  Batch Type<span>*</span>
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                  <ppl-dropdown-select formControlName="batchTypeLkp" id="batchTypeLkp" class="ppl-select"
                    [options]="batchTypeOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                    [placeholder]="'Select Batch Type'" (selectionChange)="onBatchTypeChange($event)">
                  </ppl-dropdown-select>
                </nz-form-control>
              </nz-row>
            </nz-form-item>

            <!-- Batch Reason -->
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
              <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="reasonCodeLkp" class="ppl-form-label">
                  Batch Reason<span>*</span>
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                  <ppl-dropdown-select formControlName="reasonCodeLkp" id="reasonCodeLkp" class="ppl-select"
                    [options]="batchReasonOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                    [placeholder]="'Select Batch Reason'">
                  </ppl-dropdown-select>
                </nz-form-control>
              </nz-row>
            </nz-form-item>

            <!-- ══════════════════════════════════════════════════════════════
                 AUTH ADJUSTMENT CRITERIA — only when Batch Type = AA
                 ══════════════════════════════════════════════════════════════ -->
            <ng-container *ngIf="isAuthAdjustmentMode">

              <div class="or-divider">
                <span class="or-divider-text">Auth Adjustment Criteria</span>
              </div>

              <div class="auth-adjustment-grid">
              <!-- Row 1: Participant ID -->
              <nz-row>
              <nz-form-item nz-col [nzSm]="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authParticipantId" class="ppl-form-label">
                    Participant ID<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <input nz-input formControlName="authParticipantId" id="authParticipantId"
                      placeholder="Enter Participant ID" class="full-width auth-participant-id"
                      (input)="onAuthCriteriaChange()" />
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
              </nz-row>

              <!-- Row 2: From Date | To Date -->
              <nz-row>
              <nz-form-item nz-col [nzSm]="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authFromDate" class="ppl-form-label">
                    From Date<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <nz-date-picker formControlName="authFromDate" id="authFromDate"
                          nzFormat="MM/dd/yyyy" [nzPlaceHolder]="'MM/dd/yyyy'" class="full-width"
                          (nzOnChange)="onAuthCriteriaChange()">
                    </nz-date-picker>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>

              <nz-form-item nz-col [nzSm]="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authToDate" class="ppl-form-label">
                    To Date<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <nz-date-picker formControlName="authToDate" id="authToDate"
                          nzFormat="MM/dd/yyyy" [nzPlaceHolder]="'MM/dd/yyyy'" class="full-width"
                          (nzOnChange)="onAuthCriteriaChange()">
                    </nz-date-picker>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
              </nz-row>

              <!-- Row 3: Old Service Code | New Service Code -->
              <nz-row>
              <nz-form-item nz-col [nzSm]="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="oldServiceCode" class="ppl-form-label">
                    Old Service Code<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div class="auth-picker-row">
                      <ppl-dropdown-select formControlName="oldServiceCode" id="oldServiceCode" class="ppl-select"
                        [options]="oldServiceOptions" [optionLabel]="'service_description'"
                        [optionValue]="'service_code'" [placeholder]="'Select Old Service Code'"
                        (selectionChange)="onOldServiceSelected($event)">
                      </ppl-dropdown-select>
                      <button pButton type="button" icon="pi pi-search"
                        class="p-button-rounded p-button-text p-button-sm auth-search-btn"
                        title="Load Used Service Codes"
                        [disabled]="isLoadingOldServices"
                        (click)="loadOldAuths()">
                      </button>
                    </div>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>

              <nz-form-item nz-col [nzSm]="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="newServiceCode" class="ppl-form-label">
                    New Service Code<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <ppl-dropdown-select formControlName="newServiceCode" id="newServiceCode" class="ppl-select"
                      [options]="newServiceOptions" [optionLabel]="'service_description'"
                      [optionValue]="'service_code'" [placeholder]="'Defaults to Old Service Code'"
                      (selectionChange)="onNewServiceSelected($event)">
                    </ppl-dropdown-select>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
              </nz-row>

              <!-- Row 4: Old Auth Number -->
              <nz-row>
              <nz-form-item nz-col [nzSm]="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="oldAuthId" class="ppl-form-label">
                    Old Auth Number<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                    <div class="auth-picker-row">
                      <nz-select formControlName="oldAuthId" id="oldAuthId"
                        nzShowSearch nzAllowClear
                        [nzPlaceHolder]="'Select Old Service Code first'"
                        (ngModelChange)="onOldAuthSelected($event)"
                        class="full-width">
                        <nz-option
                          *ngFor="let opt of oldAuthOptions"
                          [nzValue]="opt.tas_authorization_detail_id"
                          [nzLabel]="getOldAuthLabel(opt)">
                        </nz-option>
                      </nz-select>
                    </div>
                    <small class="auth-hint">Used authorizations for this participant in the date range.</small>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
              </nz-row>

              <!-- Row 5: New Auth Number -->
              <nz-row>
              <nz-form-item nz-col [nzSm]="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
                <nz-row>
                  <nz-form-label [nzSm]="5" [nzXs]="24" nzFor="newAuthId" class="ppl-form-label">
                    New Auth Number<span>*</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="18" [nzXs]="24" class="ppl-form-control">
                    <div class="auth-picker-row">
                      <nz-select formControlName="newAuthId" id="newAuthId"
                        nzShowSearch nzAllowClear
                        [nzPlaceHolder]="'Select New Service Code first'"
                        [nzLoading]="isLoadingNewAuths"
                        class="full-width">
                        <nz-option
                          *ngFor="let opt of newAuthOptions"
                          [nzValue]="opt.tas_authorization_detail_id"
                          [nzLabel]="getNewAuthLabel(opt)">
                        </nz-option>
                      </nz-select>
                      <button pButton type="button" icon="pi pi-search"
                        class="p-button-rounded p-button-text p-button-sm auth-search-btn"
                        title="Load Active Authorizations"
                        [disabled]="isLoadingNewAuths || !adjustmentForm.get('newServiceCode')?.value"
                        (click)="loadNewAuths()">
                      </button>
                    </div>
                    <small class="auth-hint">Active authorizations filtered to match the New Service Code.</small>
                  </nz-form-control>
                </nz-row>
              </nz-form-item>
              </nz-row>
              </div>

            </ng-container>
            <!-- ── end Auth Adjustment ───────────────────────────────────── -->


            <!-- ══════════════════════════════════════════════════════════════
                 STANDARD CRITERIA + FILE UPLOAD — all other batch types
                 ══════════════════════════════════════════════════════════════ -->
            <ng-container *ngIf="!isAuthAdjustmentMode">

              <!-- Search Criteria divider -->
              <div class="or-divider">
                <span class="or-divider-text">Search Criteria</span>
              </div>

              <!-- Search Criteria rows -->
              <div class="input-section" [class.disabled-section]="inputMode === 'upload'">
                <div class="section-label-row">
                  <ppl-button *ngIf="inputMode !== 'upload' && criteriaFormArray.length === 0"
                    label="Add Criteria" icon="fa fa-plus" [customClass]="'ghost-button'" iconPosition="left"
                    (click)="selectCriteriaMode()"></ppl-button>
                </div>

                <ng-container *ngIf="criteriaFormArray.controls.length > 0">
                  <div formArrayName="criteria" class="table-wrapper">
                    <table class="criteria-table">
                      <thead>
                        <tr>
                          <th class="col-field">Column</th>
                          <th class="col-field">Operator</th>
                          <th class="col-field">Value</th>
                          <th class="col-actions">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of criteriaFormArray.controls; let i = index" [formGroupName]="i">
                          <td class="cell">
                            <ppl-dropdown-select formControlName="columnLkp" class="ppl-select"
                              [options]="columnOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                              [placeholder]="'Select Column'">
                            </ppl-dropdown-select>
                            <small class="validation-error"
                              *ngIf="row.get('columnLkp')?.invalid && row.get('columnLkp')?.touched">
                              Column is required
                            </small>
                          </td>
                          <td class="cell">
                            <ppl-dropdown-select formControlName="operatorLkp" class="ppl-select"
                              [options]="operatorOptions" [optionLabel]="'label'" [optionValue]="'value'"
                              [placeholder]="'Select Operator'">
                            </ppl-dropdown-select>
                            <small class="validation-error"
                              *ngIf="row.get('operatorLkp')?.invalid && row.get('operatorLkp')?.touched">
                              Operator is required
                            </small>
                          </td>
                          <td class="cell">
                            <input nz-input formControlName="value" placeholder="Enter Value" class="full-width" />
                            <small class="validation-error"
                              *ngIf="row.get('value')?.invalid && row.get('value')?.touched">
                              Value is required
                            </small>
                          </td>
                          <td class="cell cell-actions">
                            <button pButton type="button" icon="pi pi-plus-circle"
                              class="p-button-rounded p-button-text p-button-sm action-btn"
                              (click)="addCriteriaRow(i)"></button>
                            <button pButton type="button" icon="pi pi-trash"
                              class="p-button-rounded p-button-text p-button-sm action-btn-danger"
                              (click)="removeCriteriaRow(i)"></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ng-container>
              </div>

              <!-- OR divider -->
              <div class="or-divider">
                <span class="or-divider-text">OR</span>
              </div>

              <!-- Upload File section -->
              <div class="input-section" [class.disabled-section]="inputMode === 'criteria'">
                <h4 class="section-label">Upload a File</h4>
                <ppl-upload [disableFileTypeSelection]="true" [fileType]="'Bulk Adjustment Files'"
                  [showFileList]="true" [fileList]="fileList" [mode]="'write'" [flow]="'massAdjustment'"
                  (fileSelected)="onFileSelected($event)" (filesUploaded)="onFilesUploaded($event)"
                  (fileRemoved)="onFileRemoved($event)" (uploadError)="onUploadError($event)">
                </ppl-upload>
              </div>

            </ng-container>
            <!-- ── end standard criteria ─────────────────────────────────── -->

          </form>
        </div>
      </ppl-accordion>
    </div>
  </div>
</div>
